import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';




import {ApiMessageService} from '../../core/api-message.service';
import {Gerarchia} from './gerarchia.model';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {MODULE_ANAGRAFICA} from '../../app-routing.module';
import {Table} from '../../common/model/table.model';

@Injectable()
export class GerarchiaService extends CommonService<Gerarchia> {

  public static ROUTE = 'gerarchia';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): Gerarchia {
    return JsonBaseBuilder.jsonToGerarchia(json);
  }

  public getModule(): string {
    return MODULE_ANAGRAFICA;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return GerarchiaService.ROUTE;
  }

  public getTable(items: Gerarchia[]): Table {
    return Table.buildBaseTable(Gerarchia.getTableKeys(), items);
  }

}
